<div *ngIf="!(isMobile$ | async)">
  <table mat-table [dataSource]="accounts">
    <!-- Image Column -->
    <ng-container matColumnDef="image">
      <th mat-header-cell *matHeaderCellDef>Provider</th>
      <td mat-cell *matCellDef="let element">
        <img
          class="integration-icon"
          [src]="element.integration | smartDeviceIntegrationImage"
          [alt]="element.integration" />
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Account</th>
      <td mat-cell *matCellDef="let element">
        {{ element.user_identifier }}
      </td>
    </ng-container>

    <!-- Connected Column -->
    <ng-container matColumnDef="connected">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element">
        {{ element.disconnected ? 'Disconnected' : 'Connected' }}
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngTemplateOutlet="actionsTemplate; context: { account: element }"></ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.highlight-warning]="row.disconnected"></tr>
  </table>
</div>

<div *ngIf="isMobile$ | async" class="mobile-devices-table">
  <mat-card *ngFor="let account of accounts" [class.highlight-warning]="account.disconnected">
    <mat-card-content>
      <div fxLayout fxLayoutGap="12px">
        <img
          class="integration-icon"
          [src]="account.integration | smartDeviceIntegrationImage"
          [alt]="account.integration" />

        <div fxFlex fxLayout="column" fxLayoutGap="4px">
          <div fxLayoutAlign="space-between center" fxLayoutGap="12px">
            <a class="strong ellipsis">{{ account.user_identifier }}</a>
            <ng-container *ngTemplateOutlet="actionsTemplate; context: { account: account }"></ng-container>
          </div>

          <div style="display: inline-block">{{ account.disconnected ? 'Disconnected' : 'Connected' }}</div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #actionsTemplate let-account="account">
  <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
  <sbnb-more-menu-trigger
    *ngIf="!loading"
    [disabled]="!canAction"
    [matTooltip]="canAction ? null : 'You do not have permission to perform actions'"
    alt="Actions"
    [matMenuTriggerFor]="canAction ? actionsMenu : null"></sbnb-more-menu-trigger>
  <mat-menu #actionsMenu="matMenu">
    <button *ngIf="account.disconnected" mat-menu-item (click)="reconnectAccount(account)">
      <span>Reconnect</span>
    </button>
    <button mat-menu-item (click)="deleteAccount(account)">
      <span>Delete</span>
    </button>
  </mat-menu>
</ng-template>
